import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { usuario } from './models/usuario';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tributopersona } from './models/tributopersona';
import { vencimientos } from './models/vencimientos';
import { Cidi } from './models/cidi';
import { mail } from './models/email';

@Injectable({
  providedIn: 'root'
})
export class InicioService {


  constructor(private http: HttpClient) { }

  getUsuario(token: string): Observable<usuario> {
    debugger;
    if (token != null)
      return this.http.get<usuario>(`${environment.urlService}/Seguridad/Login?atoken=${token}`);
  }

  getCuitCidi(token: string,idJuri:number):Observable<Cidi>{
    debugger;
    return this.http.get<Cidi>(`${environment.urlCidi}/?token=${token}&IdJurisdiccion=${idJuri}`);
  }

  //aca me trae los tributos de la persona le envio el cuil
  getTributoUsuario(personaid: string,cuil:string): Observable<tributopersona> {
    debugger;
    //solamente para probar hardcodiamos pero le vamos a pasar el cuil por el logue de cidi
    
    return this.http.get<tributopersona>(`${environment.urlService}/DatosTributoPersona/BuscarTodosTributo?IdPersona=${personaid}&Cuit=${cuil}&IdJurisdiccion=${environment.codigoJur}`);
  }

  getvencimientos(): Observable<vencimientos> {
    return this.http.get<vencimientos>(`${environment.urlService}/DatosTributoPersona/vencimientos?IdJurisdiccion=${environment.codigoJur}`);
  }

  addEmail(data : mail):Observable<any>{
    debugger;
    return this.http.post<any>(`${environment.urlProveedores}CargarEmail`,data);
  }

  



}
